import { NgModule } from '@angular/core';
import { AddClassDirective } from './add-class.directive';

@NgModule({
  declarations: [AddClassDirective],
  exports: [AddClassDirective],
})
export class AddClassModule {}
